import { useQuery } from "@tanstack/react-query";
import { getPlayerGoals } from "@/lib/api";
import { useScopedKey } from "@/lib/queryClient";
import { useScopeStore } from "@/stores/scope";

/**
 * Coach-side goals list query. Mutations live in `useCoachGoals`;
 * this read hook is shared by the player-first board and Players
 * surface so goal attention signals come from one cache key.
 */
export function useCoachGoalsList(playerId?: string) {
  const teamId = useScopeStore((s) => s.teamId);
  return useQuery({
    queryKey: useScopedKey("player-goals", { player_id: playerId ?? null }),
    queryFn: () => getPlayerGoals(playerId),
    enabled: !!teamId,
  });
}
